import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContactUsModel } from 'src/app/core/models/contact-us.model';
import { ContactUsService } from 'src/app/core/services/contact-us.services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

/***
 * Footer Component
 */
export class FooterComponent implements OnInit {
currentLang = localStorage.getItem('lang') || 'ar';

  @Input() footerVariant: string;
  @Input() hideFooter: boolean;

  newsForm!: UntypedFormGroup;
  submitted = false;

  //Get Year
  year = new Date().getFullYear()
  contactUs:ContactUsModel[] = [];
  constructor(private formBuilder: UntypedFormBuilder,private contactUsService:ContactUsService) { }

  ngOnInit(): void {
    this.currentLang = localStorage.getItem('lang')
    this.contactUsService.getAll()
    .subscribe(result=>{
      this.contactUs = result;
    })
    /**
     * Form Validatyion
     */
    this.newsForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  // convenience getter for easy access to form fields
  get form() { return this.newsForm.controls; }

  /**
   * On submit form
   */
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.newsForm.invalid) {
      return;
    }
  }

}
